module.exports = __webpack_public_path__ + "img/table.545b1dfe.jpg";